import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { ThemeProvider } from "@emotion/react"
import styled from "@emotion/styled"
import { connect } from "react-redux"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"
import { setCookie } from "../../utils/cookies"
import getJSON from "../../utils/getJSON"

import SEO from "../seo"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import Header from "../header"
import ExternalScripts from "../externalscripts"
import handleErrors from "../../utils/fetchErrorHandler"

import {
  setUserToken,
  setResponseComplete,
  setCurrentSection,
  setProgress,
  setSubscriptionId,
  setCustomerId,
  setEmailCapture,
  setHeaderVariant,
} from "../../actions"

const DEVMODE = process.env.GATSBY_DEVMODE === "1"
const mageURL = process.env.GATSBY_MAGENTO_API_URL
const mageProtocol = process.env.GATSBY_MAGENTO_API_PROTOCOL
const bearerToken = process.env.GATSBY_MAGENTO_API_BEARER_TOKEN

const Main = styled.main`
  height: 100%;
  /* min height set on body to preserve scroll events */
  /* min-height: 675px; */
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  /* ${queries.medium`
    min-height: 750px;
  `} */
  &.mousedown {
    *:focus {
      outline: none;
    }
  }
  &.no-route {
    align-items: stretch;
    > div {
      align-items: flex-start;
    }
  }
`

const Layout = (props) => {
  const {
    userToken,
    setResponseComplete,
    setUserToken,
    setCurrentSection,
    setProgress,
    setHeaderVariant,
  } = props

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const getUserToken = async () => {
    const tokenUrl = `${mageProtocol}://${mageURL}/rest/V1/quiz/token/generate`
    fetch(tokenUrl, {
      method: "POST",
      withCredentials: true,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${bearerToken}`,
      },
    })
      .then((res) => res.json())
      .then((resJson) => {
        if (!!resJson.token) {
          let token = resJson.token
          setUserToken(token)
          if (typeof window !== `undefined`) {
            localStorage.setItem("userToken", token)
            setCookie("quiz-user-token", token, 30)
          }
        }
      })
  }

  const addQuizJsonToPage = (json) => {
    let jsonScript = document.createElement("script")
    jsonScript.classList.add("quiz-json")
    jsonScript.type = "application/ld+json"
    jsonScript.text = json
    const gatsbyWrap = document.querySelectorAll("#gatsby-focus-wrapper")[0]
    if (!!gatsbyWrap) {
      gatsbyWrap.appendChild(jsonScript)
    }
    setResponseComplete()
  }

  const getQuizJson = () => {
    /**
     ** to test locally
     * place stringified file `static/quiz-version-5`
     * add GATSBY_DEVMODE=1 in env file
     */
    debugger
    let quizJsonUrl = DEVMODE
      ? `/quiz-version-${process.env.GATSBY_QUIZ_VERSION}`
      : `${mageProtocol}://${mageURL}/rest/V1/quiz/version/${process.env.GATSBY_QUIZ_VERSION}`
    fetch(quizJsonUrl, {
      method: "GET",
      withCredentials: true,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${bearerToken}`,
      },
    })
      .then(handleErrors)
      .then((res) => res.json && res.json())
      .then((resJson) => {
        //debugger
        addQuizJsonToPage(resJson)
        if (typeof window !== `undefined`) {
          localStorage.setItem("quizJson", resJson)
        }
      })
  }

  const browserSectionCorrection = () => {
    props.setEmailCapture(false)

    const urlSection = window.location.pathname.split("/").filter(Boolean).pop()

    if (urlSection !== "") {
      setCurrentSection(urlSection)
      setProgress(0)
    } else {
      cleanReset()
    }
  }

  useEffect(() => {
    if (typeof window !== `undefined`) {
      // Set currentSection from URL pathname on initial load and when location changes
      const pathname = props.location?.pathname || window.location.pathname
      const urlSectionFromPath = pathname.split("/").filter(Boolean).pop()

      if (
        urlSectionFromPath &&
        urlSectionFromPath !== "" &&
        urlSectionFromPath !== "results" &&
        urlSectionFromPath !== "save-results"
      ) {
        // Normalize "basics" to "basics"
        const normalizedSection =
          urlSectionFromPath === "basics" ? "basics" : urlSectionFromPath
        // Always set from URL, even if Redux already has a value (to handle refresh)
        setCurrentSection(normalizedSection)
        localStorage.setItem("currentSection", normalizedSection)
      } else if (urlSectionFromPath === "" || !urlSectionFromPath) {
        cleanReset()
        setProgress(0)
        setCurrentSection("intro")
        localStorage.setItem("currentSection", "intro")
      }
    }
  }, [props.location?.pathname, setCurrentSection])

  useEffect(() => {
    // set header to non-intro mode on all pages except main page
    if (typeof window !== `undefined`) {
      const pathname = props.location?.pathname || window.location.pathname
      const isMainPage = pathname === "/hair/women/quiz/" || pathname === ""
      if (!isMainPage) {
        setHeaderVariant(false)
      }
    }
  }, [props.location, setHeaderVariant])

  const cleanReset = () => {
    // setCurrentSection("intro")
    setProgress(0)
  }

  useEffect(() => {
    if (typeof window !== `undefined`) {
      window.addEventListener("popstate", browserSectionCorrection)

      const fetchData = async () => {
        await getUserToken()

        let quizJson = getJSON()
        //debugger
        if (quizJson) {
          setResponseComplete()
        } else {
          getQuizJson()
        }
      }

      fetchData()

      if (window.location.href.split("/").slice(-1)[0] === "") {
        cleanReset()
      }

      const getCampaignItems = () => {
        const self = window.location.toString()
        const qtring = self.split("?")
        const campaign = {}
        if (qtring.length > 1) {
          const pairs = qtring[1].split("&")
          pairs.forEach((item) => {
            var keyval = item.split("=")
            var newKey =
              keyval[0] === "utm_campaign"
                ? "name"
                : keyval[0].replace("utm_", "")
            campaign[newKey] = decodeURIComponent(keyval[1])
          })
        }
        return campaign
      }

      if (props.location && props.location.search !== undefined) {
        if (!props.location.search.includes("id=")) {
          setTimeout(() => {
            segmentEvent("Quiz First Page Viewed", {
              quiz_version: process.env.GATSBY_QUIZ_VERSION,
              token: userToken,
              context: {
                campaign: getCampaignItems(),
              },
            })
          }, 2000)
        }
      }
    }

    return function () {
      window.removeEventListener("popstate", browserSectionCorrection)
    }
  }, [])

  const [mouseDown, setMouseDown] = useState(false)

  /** mouseDown is used to removed outline style for focused elements on mouse click but show for tab navigation */
  useEffect(() => {
    document.addEventListener("mousedown", () => {
      setMouseDown(true)
    })

    document.addEventListener("keydown", (e) => {
      if (e.key === "Tab" || e.keyCode === 9) {
        setMouseDown(false)
      }
    })
  }, [])

  let path =
    typeof props.location !== `undefined` &&
    typeof props.location.pathname !== `undefined`
      ? props.location.pathname
      : ""

  let strippedPath = !!path ? path.replace(/[^0-9a-zA-Z]/g, "") : ""

  strippedPath = strippedPath.split("/").filter(Boolean).pop()

  const { children } = props

  const renderSEO = () => {
    if (props.path !== "/" && props.path !== "/results") {
      let basicTitle
      if (props.currentSection.includes("hormones")) {
        basicTitle = "hormones"
      } else if (props.currentSection === "intro") {
        basicTitle =
          getJSON()?.intro?.[props.quizProgress]?.globalid ||
          "Hair Wellness Quiz"
      } else {
        basicTitle = props.currentSection
      }
      const title =
        basicTitle === "basics"
          ? "The Basics"
          : `${basicTitle.slice(0, 1).toUpperCase()}${basicTitle.slice(1)}`
      return (
        <SEO
          title={title}
          description="Take Nutrafol's personalized hair wellness evaluation for tailored insights and solutions. Start your journey to healthier hair today!"
        />
      )
    }
  }

  return (
    <>
      {renderSEO()}
      <ThemeProvider theme={theme}>
        <Header
          siteTitle={data.site.siteMetadata.title}
          location={props.location}
          mouseDown={mouseDown}
        />
        <Main
          className={`app-main ${
            strippedPath === "" ? "no-route" : strippedPath
          }  ${mouseDown ? "mousedown" : ""}`}
        >
          {children}
        </Main>
        <ExternalScripts />
      </ThemeProvider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

const mapStateToProps = (state) => {
  return {
    userToken: state.tokenReducer.token,
    currentSection: state.sectionReducer.currentSection,
    currentGlobalId: state.globalIdReducer.currentGlobalId,
    quizProgress: state.progressReducer.quizProgress,
    subscription_id: state.setSubscriptionIdReducer.subscription_id,
    customer_id: state.setCustomerIdReducer.customer_id,
    email_capture: state.progressReducer.email_capture,
  }
}

export default connect(mapStateToProps, {
  setUserToken,
  setResponseComplete,
  setCurrentSection,
  setProgress,
  setSubscriptionId,
  setCustomerId,
  setEmailCapture,
  setHeaderVariant,
})(Layout)
